import React, { useState, useMemo, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import { getData } from "../../../../services";
import ReportTasks from "./ReportTasks";

const ProjectReportTask = () => {
  const { project_id: id } = useParams();
  const [cookies] = useCookies();
  const [information, setInformation] = useState();

  const getProjectsData = useCallback(async () => {
    try {
      const res = await getData({
        endpoint: "Project/getProjectDetails",
        params: {
          project_id: id,
        },
        token: cookies.e_t,
      });
      if (res) {
        setInformation(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, [cookies.e_t]);

  useEffect(() => {
    getProjectsData();
  }, [getProjectsData]);

  return (
    <>
      <ReportTasks information={information} type={"Project"} id={id} />
    </>
  );
};

export default ProjectReportTask;
